/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// 'use strict'
/*  */

expocadfx.comparer = function( key, asc) {
	return function( a, b) {

        function isNum( c) {
            var charCode = c.charCodeAt(0);
            return (charCode > 47 && charCode < 58);  // 46 = '.' ??
        }
        
        function getChunk( str, len, index) {
            var chunk = str.charAt( index);
            var char;
            index += 1;
            if( isNum( chunk)) {
                while( index < len) {
                    char = str.charAt( index);
                    if( !isNum( char)) {
                        break;
                    }
                    chunk += char;
                    index += 1;
                }
            }
            else {
                while( index < len) {
                    char = str.charAt( index);
                    if( isNum( char)) {
                        break;
                    }
                    chunk += char;
                    index += 1;
                }
            }
            return chunk;
        }
		
		if( a.hasOwnProperty( "priority")) {
			if( a.priority < b.priority) {
				return 1;
			}
			else if( a.priority > b.priority) {
				return -1;
			}
		}
        
        var aLen = a[ key].length;
        var bLen = b[ key].length;
        var aIndex = 0;
        var bIndex = 0;
        var aChunk = "";
        var bChunk = "";
        var aNum = 0;
        var bNum = 0;
        var result = 0;
		var direction = asc ? 1 : -1;
//			console.log( "direction: " + direction);
        
        while( aIndex < aLen && bIndex < bLen) {
            aChunk = getChunk( a[ key], aLen, aIndex);
            aIndex += aChunk.length;
            
            bChunk = getChunk( b[ key], bLen, bIndex);
            bIndex += bChunk.length;
            
            if( isNum( aChunk.charAt( 0)) && isNum( bChunk.charAt( 0)) ) {
                aNum = parseInt( aChunk, 10);
                bNum = parseInt( bChunk, 10);
                if( aNum < bNum) {
                    return -1 * direction;
                }
                else if( aNum > bNum) {
                    return  direction;
                }
            }
            else {
                if( aChunk.toLocaleLowerCase() < bChunk.toLocaleLowerCase()) {
                    return  -1 * direction;
                }
                else if( aChunk.toLocaleLowerCase() > bChunk.toLocaleLowerCase()) {
                    return  direction;
                }
            }
        }
        if( result === 0) {
            result = aLen - bLen;
            if( result < 0) {
                result = -1;
            }
            if( result > 0) {
                result = 1;
            }
        }
		
		
        return result * direction;
	};
};